import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { emailValidator } from '@lx/core/validators';

export function customEmailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const email = control.value;
    if (!email) {
      return null;
    }
    if (emailValidator(email)) {
      return null; // Valid email
    }
    return { invalidEmail: { message: $localize`Please enter a valid email address (for example: your.name@domain.com)` } };
  };
}
